import React from 'react';
import { hitZoneCalc } from '../../utils/hitZoneCalc';
import HitCourseModal from '../video/HitCourseModal';
import { chooseColorCode } from '../../utils/color/commonColor';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { trackmanHitZoneCalc } from '../../utils/trackmanHitZoneCalc';

function TrackmanHitCourseChart({data, ballCodeArr, colorType, checkObj}) {
    let filterData = _.filter(data, (item, idx) => {
        let condi = false;
        if(checkObj[item['ballCode']]) {
            condi = true;
        }

        return condi;
        // return true;
    });

    let calcData = trackmanHitZoneCalc(300, filterData);

    const { t } = useTranslation();

    let hitResultObj = [
        {hitResultCode : 6613, hitResultName: '홈런', hitResultEng: 'homerun'},
        {hitResultCode : 6610, hitResultName: '3루타', hitResultEng: 'triple'},
        {hitResultCode : 6607, hitResultName: '2루타', hitResultEng: 'double'},
        {hitResultCode : 6604, hitResultName: '1루타', hitResultEng: 'single'},
        {hitResultCode : 6602, hitResultName: '플라이아웃', hitResultEng: 'flyout'},
        {hitResultCode : 6605, hitResultName: '땅볼아웃', hitResultEng: 'grounder'},
        {hitResultCode : 6699, hitResultName: '기타', hitResultEng: 'other'}
    ]

    function ballCodeColorHandler(ballCode) {
        let ballCodeObj = _.find(ballCodeArr, (item) => (item['code'] === ballCode));

        if(ballCodeObj) {
            return ballCodeObj['color'];
        } else {
            return '#ffffff';
        }
    }

    return (
        <>
            <svg width="380" height="330">
                <g transform='translate(40, 20)'>
                    <image 
                    href={`${process.env.PUBLIC_URL}/image/ground_green.jpeg`} 
                    width={300} 
                    height={300} />
                    {calcData.map((item, idx) => (
                        item['x'] &&
                        <HitCourseModal 
                        gameRecordId={item['gameRecordId']} cx={item['x']} cy={item['y']} 
                        color={(colorType === 'hitResult') ? item['color'] : ballCodeColorHandler(item['ballCode'])}
                        key={item['key']}
                        />
                    ))}
                </g>
                <g transform='translate(300, 230)'>
                    {hitResultObj.map((item, idx) => (
                    <g key={item['hitResultCode']}>
                    <circle cx={5} cy={15*idx} r={5} 
                    fill={chooseColorCode(item['hitResultCode'])}
                    key={"circle_"+item['hitResultCode']}
                    ></circle>
                    <text dy={15*idx+4} dx={15} fontSize="11px"
                    key={"text_"+item['hitResultCode']}
                    >
                        {t(item['hitResultEng'])}
                    </text>
                    </g>
                    ))}
                </g>
                <g transform='translate(30, 215)'>
                    {ballCodeArr.map((item, idx) => (
                    <g key={item['code']}>
                    <circle cx={5} cy={15*idx} r={5} 
                    fill={item['color']}
                    key={"circle_"+item['code']}
                    ></circle>
                    <text dy={15*idx+4} dx={15} fontSize="11px"
                    key={"text_"+item['code']}
                    >
                        {t(item['name'])}
                    </text>
                    </g>
                    ))}
                </g>
            </svg>
        </>
    )
}

export default TrackmanHitCourseChart;